import React from 'react';

const Companieswork = () => {
  return (
    <section className="companies-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left side content */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="pe-lg-4">
              <h2 className="fw-bold mb-4">Companies We Work With</h2>
              <p className="lead mb-4">
                We collaborate with forward-thinking companies to deliver innovative software solutions. Our partnerships span across various industries, bringing cutting-edge technology and expertise to every project.
              </p>
            </div>
          </div>
          
          {/* Right side image */}
          <div className="col-lg-6">
            <div className="position-relative">
              <img 
                src="/images/clients/compines.png" 
                alt="Companies We Work With" 
                className=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Companieswork;
